import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgStopFilled = ({ size, title = 'StopFilled', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <rect width={12} height={12} x={6} y={6} fill="currentColor" fillRule="evenodd" rx={1} />
    </svg>
);

export default withIcon(SvgStopFilled);
